jQuery(document).ready(function(){


  
});




jQuery(document).on('shopify:section:load', function() {})




function init(){
  
  // Default, to not to hide filtered content 
  // (if browser open with params old window with filtering)
    if ($('.collection__content.hide').length) {
      $('.collection__content').addClass("show");
    } else {

    }

    // body
    $(window).resize(function() {

    });
  
  /*
      if ($(window).width() <= 798) {
        $('.sidebar-block').each(function(index) { 
            if($(this).attr('data-sidebar-block-state') == null || $(this).attr('data-sidebar-block-state') == 'closed' )
            { 
                $(this).attr('data-sidebar-block-state', 'close');
                $(this).attr('close', '');
                $(this).addClass('axl');
            } 
        });
        
      } else {

      } 
      
        $('.sidebar-block').each(function(index) { 
            if( $(this).hasClass('open')  )
            { 
                $(this).addClass('fck');
            } 
        });
      
      
  */
  

    if ($(window).width() <= 798) {
      if ($('body.filter__mobile_open').length) {
        $('body').addClass("filter__mobile_close");
      } else {

      }
    }

  
  
    // onClick Filter button
    // hide all wrapped products as on design show just fitering without products
    $('.filter__btn').on('click', function(e) {
      
      // body
      if ($('body.filter__mobile_open').length) {
        $('body').removeClass("filter__mobile_open");
        $('body').addClass("filter__mobile_close");
      } else {

      }
      
      // content
      if ($('.collection__content.hide').length) {
      } else {
        $('.collection__content').removeClass("show");
        $('.collection__content').addClass("hide");
      }
      
      // Highight Sort button 
      if ($('.sort__btn.active').length) {
        $(this).addClass("active");
        $('.sort__btn').removeClass("active");
         $('#mobile__buttons_wrap').addClass("active"); // ??
      } else {
        $(this).addClass("active");
        $('#mobile__buttons_wrap').addClass("active"); // ??
      }
      
      $('.filter__content').toggleClass("filter__hide filter__show"); 
      
      
      if( $('.filter__content').hasClass('filter__show') ) {
        $('.sort__content').removeClass("sort__show");
        $('.sort__content').addClass("sort__hide");
          $('.sort__btn').addClass("hide"); // ?? hide sort button clicking on filter btn
        
        $('.results__btn').removeClass("hide");
        $('.results__btn').addClass("show");
      }
     
      // body
      $( "body" ).toggleClass( "filter__mobile_close filter__mobile_open" );

       if( $('body').hasClass('filter__mobile_open') ) {
        $('body').removeClass("filter__mobile_close");
        $('body').addClass("filter__mobile_open");
      } 
      
        
      e.preventDefault();
    });
      
  
    $('.sort__btn').on('click', function(e) {
      if ($('.collection__content.hide').length) {
      } else {
        $('.collection__content').removeClass("show");
        $('.collection__content').addClass("hide");
      }
      
      // Highight Filter button 
      if ($('.filter__btn.active').length) {
        $(this).addClass("active");
        $('.filter__btn').removeClass("active");
        $('#mobile__buttons_wrap').addClass("active"); // ??
      } else {
        $(this).addClass("active");
         $('#mobile__buttons_wrap').addClass("active"); // ?? 
      }
      
      
      $('.sort__content').toggleClass("sort__hide sort__show");  
      
      
      if( $('.sort__content').hasClass('sort__show') ) {
        $('.filter__content').removeClass("filter__show");
        $('.filter__content').addClass("filter__hide");
         $('.filter__btn').addClass("hide"); //?? hide filter button by clicking on sort btn
        
        $('.results__btn').removeClass("hide");
        $('.results__btn').addClass("show");
      }

      // body
      $( "body" ).toggleClass( "filter__mobile_close filter__mobile_open" );

      if( $('body').hasClass('filter__mobile_close') ) {
        $('body').removeClass("filter__mobile_close");
        $('body').addClass("filter__mobile_open");
      }
      

      e.preventDefault();
    });

  
  
    $('.results__btn, #mobile__buttons_wrap .clear-active-filter').on('click', function(e) {
      
      // body    
      $('body').removeClass("filter__mobile_open");
      $('body').addClass("filter__mobile_close");
      
      $('.filter__content').removeClass("filter__show");
      $('.filter__content').addClass("filter__hide");
      $('.sort__content').removeClass("sort__show");
      $('.sort__content').addClass("sort__hide");
      
      $('.results__btn').toggleClass("hide show");
      $('.collection__content').toggleClass("show hide");
      
       
      
      
      $('#mobile__buttons_wrap').removeClass("active"); // ??
      
      if( $('#mobile__buttons_wrap .filter__btn').hasClass('active') ) {
        $( this ).removeClass("hide");  // ??
        $( '#mobile__buttons_wrap .sort__btn' ).removeClass("hide");  // ??
      } else {
        $( this ).removeClass("show");  // ??
      }
      
      if( $('#mobile__buttons_wrap .sort__btn').hasClass('active') ) {
        $( this ).removeClass("hide");  // ??
        $( '#mobile__buttons_wrap .filter__btn' ).removeClass("hide");  // ??
      } else {
        $( this ).removeClass("show");  // ??
      }
       
      
      $("html, #mobile__buttons_wrap").animate({ scrollTop: 0 }, "slow");

      
      e.preventDefault();
    });

  
}



if (document.readyState === "complete" || document.readyState === "loaded" || document.readyState === "interactive") {
  // if doc. already loaded, init. script
  init();
} else{
  // otherwise, wait for DOMContentLoaded event and then fire init()
  document.addEventListener("DOMContentLoaded", init, false );
}